import { c as _c } from "react/compiler-runtime";
import * as React from "react";
const MavenIcon = () => {
  const $ = _c(165);
  const t0 = React.useId();
  let t1;
  if ($[0] !== t0) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = /:/g;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    t1 = t0.replace(t2, "");
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const id = t1;
  const prefix = `maven-${id}-`;
  const t2 = `${prefix}i`;
  let t3;
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <stop offset="0" stopColor="#f69923" />;
    t4 = <stop offset=".312" stopColor="#f79a23" />;
    t5 = <stop offset=".838" stopColor="#e97826" />;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t2) {
    t6 = <linearGradient id={t2} gradientUnits="userSpaceOnUse" x1="-7274.8" y1="2082.507" x2="-7243.872" y2="2046.343" gradientTransform="matrix(-.092 -.464 -.464 .092 318.72 -3557.936)">{t3}{t4}{t5}</linearGradient>;
    $[6] = t2;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = `${prefix}n`;
  let t10;
  let t11;
  let t8;
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <stop offset=".323" stopColor="#9e2064" />;
    t9 = <stop offset=".63" stopColor="#c92037" />;
    t10 = <stop offset=".751" stopColor="#cd2335" />;
    t11 = <stop offset="1" stopColor="#e97826" />;
    $[8] = t10;
    $[9] = t11;
    $[10] = t8;
    $[11] = t9;
  } else {
    t10 = $[8];
    t11 = $[9];
    t8 = $[10];
    t9 = $[11];
  }
  let t12;
  if ($[12] !== t7) {
    t12 = <linearGradient id={t7} gradientUnits="userSpaceOnUse" x1="-7503.689" y1="2086.595" x2="-7283.036" y2="2086.595" gradientTransform="matrix(-.092 -.464 -.464 .092 318.72 -3557.936)">{t8}{t9}{t10}{t11}</linearGradient>;
    $[12] = t7;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  const t13 = `${prefix}o`;
  let t14;
  let t15;
  let t16;
  let t17;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <stop offset="0" stopColor="#282662" />;
    t15 = <stop offset=".095" stopColor="#662e8d" />;
    t16 = <stop offset=".788" stopColor="#9f2064" />;
    t17 = <stop offset=".949" stopColor="#cd2032" />;
    $[14] = t14;
    $[15] = t15;
    $[16] = t16;
    $[17] = t17;
  } else {
    t14 = $[14];
    t15 = $[15];
    t16 = $[16];
    t17 = $[17];
  }
  let t18;
  if ($[18] !== t13) {
    t18 = <linearGradient id={t13} gradientUnits="userSpaceOnUse" x1="-7477.053" y1="2064.42" x2="-7345.566" y2="2064.42" gradientTransform="matrix(-.092 -.464 -.464 .092 318.72 -3557.936)">{t14}{t15}{t16}{t17}</linearGradient>;
    $[18] = t13;
    $[19] = t18;
  } else {
    t18 = $[19];
  }
  const t19 = `${prefix}p`;
  let t20;
  let t21;
  let t22;
  let t23;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <stop offset=".323" stopColor="#9e2064" />;
    t21 = <stop offset=".63" stopColor="#c92037" />;
    t22 = <stop offset=".751" stopColor="#cd2335" />;
    t23 = <stop offset="1" stopColor="#e97826" />;
    $[20] = t20;
    $[21] = t21;
    $[22] = t22;
    $[23] = t23;
  } else {
    t20 = $[20];
    t21 = $[21];
    t22 = $[22];
    t23 = $[23];
  }
  let t24;
  if ($[24] !== t19) {
    t24 = <linearGradient id={t19} gradientUnits="userSpaceOnUse" x1="-7491.296" y1="2088.633" x2="-7270.643" y2="2088.633" gradientTransform="matrix(-.092 -.464 -.464 .092 318.72 -3557.936)">{t20}{t21}{t22}{t23}</linearGradient>;
    $[24] = t19;
    $[25] = t24;
  } else {
    t24 = $[25];
  }
  const t25 = `${prefix}q`;
  let t26;
  let t27;
  let t28;
  let t29;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <stop offset="0" stopColor="#282662" />;
    t27 = <stop offset=".095" stopColor="#662e8d" />;
    t28 = <stop offset=".788" stopColor="#9f2064" />;
    t29 = <stop offset=".949" stopColor="#cd2032" />;
    $[26] = t26;
    $[27] = t27;
    $[28] = t28;
    $[29] = t29;
  } else {
    t26 = $[26];
    t27 = $[27];
    t28 = $[28];
    t29 = $[29];
  }
  let t30;
  if ($[30] !== t25) {
    t30 = <linearGradient id={t25} gradientUnits="userSpaceOnUse" x1="-7475.203" y1="2085.61" x2="-7359.244" y2="2085.61" gradientTransform="matrix(-.092 -.464 -.464 .092 318.72 -3557.936)">{t26}{t27}{t28}{t29}</linearGradient>;
    $[30] = t25;
    $[31] = t30;
  } else {
    t30 = $[31];
  }
  const t31 = `${prefix}r`;
  let t32;
  let t33;
  let t34;
  let t35;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <stop offset=".323" stopColor="#9e2064" />;
    t33 = <stop offset=".63" stopColor="#c92037" />;
    t34 = <stop offset=".751" stopColor="#cd2335" />;
    t35 = <stop offset="1" stopColor="#e97826" />;
    $[32] = t32;
    $[33] = t33;
    $[34] = t34;
    $[35] = t35;
  } else {
    t32 = $[32];
    t33 = $[33];
    t34 = $[34];
    t35 = $[35];
  }
  let t36;
  if ($[36] !== t31) {
    t36 = <linearGradient id={t31} gradientUnits="userSpaceOnUse" x1="-7491.296" y1="2065.799" x2="-7270.643" y2="2065.799" gradientTransform="matrix(-.092 -.464 -.464 .092 318.72 -3557.936)">{t32}{t33}{t34}{t35}</linearGradient>;
    $[36] = t31;
    $[37] = t36;
  } else {
    t36 = $[37];
  }
  const t37 = `${prefix}s`;
  let t38;
  let t39;
  let t40;
  let t41;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = <stop offset=".323" stopColor="#9e2064" />;
    t39 = <stop offset=".63" stopColor="#c92037" />;
    t40 = <stop offset=".751" stopColor="#cd2335" />;
    t41 = <stop offset="1" stopColor="#e97826" />;
    $[38] = t38;
    $[39] = t39;
    $[40] = t40;
    $[41] = t41;
  } else {
    t38 = $[38];
    t39 = $[39];
    t40 = $[40];
    t41 = $[41];
  }
  let t42;
  if ($[42] !== t37) {
    t42 = <linearGradient id={t37} gradientUnits="userSpaceOnUse" x1="-7504.984" y1="2066.905" x2="-7284.331" y2="2066.905" gradientTransform="matrix(-.092 -.464 -.464 .092 318.72 -3557.936)">{t38}{t39}{t40}{t41}</linearGradient>;
    $[42] = t37;
    $[43] = t42;
  } else {
    t42 = $[43];
  }
  const t43 = `${prefix}v`;
  let t44;
  let t45;
  let t46;
  let t47;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t44 = <stop offset=".323" stopColor="#9e2064" />;
    t45 = <stop offset=".63" stopColor="#c92037" />;
    t46 = <stop offset=".751" stopColor="#cd2335" />;
    t47 = <stop offset="1" stopColor="#e97826" />;
    $[44] = t44;
    $[45] = t45;
    $[46] = t46;
    $[47] = t47;
  } else {
    t44 = $[44];
    t45 = $[45];
    t46 = $[46];
    t47 = $[47];
  }
  let t48;
  if ($[48] !== t43) {
    t48 = <linearGradient id={t43} gradientUnits="userSpaceOnUse" x1="-7491.296" y1="2058.959" x2="-7270.643" y2="2058.959" gradientTransform="matrix(-.092 -.464 -.464 .092 318.72 -3557.936)">{t44}{t45}{t46}{t47}</linearGradient>;
    $[48] = t43;
    $[49] = t48;
  } else {
    t48 = $[49];
  }
  const t49 = `${prefix}y`;
  let t50;
  let t51;
  let t52;
  let t53;
  if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
    t50 = <stop offset=".323" stopColor="#9e2064" />;
    t51 = <stop offset=".63" stopColor="#c92037" />;
    t52 = <stop offset=".751" stopColor="#cd2335" />;
    t53 = <stop offset="1" stopColor="#e97826" />;
    $[50] = t50;
    $[51] = t51;
    $[52] = t52;
    $[53] = t53;
  } else {
    t50 = $[50];
    t51 = $[51];
    t52 = $[52];
    t53 = $[53];
  }
  let t54;
  if ($[54] !== t49) {
    t54 = <linearGradient id={t49} gradientUnits="userSpaceOnUse" x1="-7491.296" y1="2059.762" x2="-7270.643" y2="2059.762" gradientTransform="matrix(-.092 -.464 -.464 .092 318.72 -3557.936)">{t50}{t51}{t52}{t53}</linearGradient>;
    $[54] = t49;
    $[55] = t54;
  } else {
    t54 = $[55];
  }
  const t55 = `${prefix}z`;
  let t56;
  let t57;
  let t58;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t56 = <stop offset="0" stopColor="#f69923" />;
    t57 = <stop offset=".312" stopColor="#f79a23" />;
    t58 = <stop offset=".838" stopColor="#e97826" />;
    $[56] = t56;
    $[57] = t57;
    $[58] = t58;
  } else {
    t56 = $[56];
    t57 = $[57];
    t58 = $[58];
  }
  let t59;
  if ($[59] !== t55) {
    t59 = <linearGradient id={t55} gradientUnits="userSpaceOnUse" x1="-8307.632" y1="2040.008" x2="-8276.704" y2="2003.844" gradientTransform="matrix(.296 -.448 -.448 -.296 3456.332 -3102.04)">{t56}{t57}{t58}</linearGradient>;
    $[59] = t55;
    $[60] = t59;
  } else {
    t59 = $[60];
  }
  const t60 = `${prefix}E`;
  let t61;
  let t62;
  let t63;
  let t64;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t61 = <stop offset=".323" stopColor="#9e2064" />;
    t62 = <stop offset=".63" stopColor="#c92037" />;
    t63 = <stop offset=".751" stopColor="#cd2335" />;
    t64 = <stop offset="1" stopColor="#e97826" />;
    $[61] = t61;
    $[62] = t62;
    $[63] = t63;
    $[64] = t64;
  } else {
    t61 = $[61];
    t62 = $[62];
    t63 = $[63];
    t64 = $[64];
  }
  let t65;
  if ($[65] !== t60) {
    t65 = <linearGradient id={t60} gradientUnits="userSpaceOnUse" x1="-8536.521" y1="2044.096" x2="-8315.868" y2="2044.096" gradientTransform="matrix(.296 -.448 -.448 -.296 3456.332 -3102.04)">{t61}{t62}{t63}{t64}</linearGradient>;
    $[65] = t60;
    $[66] = t65;
  } else {
    t65 = $[66];
  }
  const t66 = `${prefix}F`;
  let t67;
  let t68;
  let t69;
  let t70;
  if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
    t67 = <stop offset="0" stopColor="#282662" />;
    t68 = <stop offset=".095" stopColor="#662e8d" />;
    t69 = <stop offset=".788" stopColor="#9f2064" />;
    t70 = <stop offset=".949" stopColor="#cd2032" />;
    $[67] = t67;
    $[68] = t68;
    $[69] = t69;
    $[70] = t70;
  } else {
    t67 = $[67];
    t68 = $[68];
    t69 = $[69];
    t70 = $[70];
  }
  let t71;
  if ($[71] !== t66) {
    t71 = <linearGradient id={t66} gradientUnits="userSpaceOnUse" x1="-8509.885" y1="2021.921" x2="-8378.397" y2="2021.921" gradientTransform="matrix(.296 -.448 -.448 -.296 3456.332 -3102.04)">{t67}{t68}{t69}{t70}</linearGradient>;
    $[71] = t66;
    $[72] = t71;
  } else {
    t71 = $[72];
  }
  const t72 = `${prefix}G`;
  let t73;
  let t74;
  let t75;
  let t76;
  if ($[73] === Symbol.for("react.memo_cache_sentinel")) {
    t73 = <stop offset=".323" stopColor="#9e2064" />;
    t74 = <stop offset=".63" stopColor="#c92037" />;
    t75 = <stop offset=".751" stopColor="#cd2335" />;
    t76 = <stop offset="1" stopColor="#e97826" />;
    $[73] = t73;
    $[74] = t74;
    $[75] = t75;
    $[76] = t76;
  } else {
    t73 = $[73];
    t74 = $[74];
    t75 = $[75];
    t76 = $[76];
  }
  let t77;
  if ($[77] !== t72) {
    t77 = <linearGradient id={t72} gradientUnits="userSpaceOnUse" x1="-8524.128" y1="2046.134" x2="-8303.475" y2="2046.134" gradientTransform="matrix(.296 -.448 -.448 -.296 3456.332 -3102.04)">{t73}{t74}{t75}{t76}</linearGradient>;
    $[77] = t72;
    $[78] = t77;
  } else {
    t77 = $[78];
  }
  const t78 = `${prefix}H`;
  let t79;
  let t80;
  let t81;
  let t82;
  if ($[79] === Symbol.for("react.memo_cache_sentinel")) {
    t79 = <stop offset="0" stopColor="#282662" />;
    t80 = <stop offset=".095" stopColor="#662e8d" />;
    t81 = <stop offset=".788" stopColor="#9f2064" />;
    t82 = <stop offset=".949" stopColor="#cd2032" />;
    $[79] = t79;
    $[80] = t80;
    $[81] = t81;
    $[82] = t82;
  } else {
    t79 = $[79];
    t80 = $[80];
    t81 = $[81];
    t82 = $[82];
  }
  let t83;
  if ($[83] !== t78) {
    t83 = <linearGradient id={t78} gradientUnits="userSpaceOnUse" x1="-8508.035" y1="2043.111" x2="-8392.076" y2="2043.111" gradientTransform="matrix(.296 -.448 -.448 -.296 3456.332 -3102.04)">{t79}{t80}{t81}{t82}</linearGradient>;
    $[83] = t78;
    $[84] = t83;
  } else {
    t83 = $[84];
  }
  const t84 = `${prefix}I`;
  let t85;
  let t86;
  let t87;
  let t88;
  if ($[85] === Symbol.for("react.memo_cache_sentinel")) {
    t85 = <stop offset=".323" stopColor="#9e2064" />;
    t86 = <stop offset=".63" stopColor="#c92037" />;
    t87 = <stop offset=".751" stopColor="#cd2335" />;
    t88 = <stop offset="1" stopColor="#e97826" />;
    $[85] = t85;
    $[86] = t86;
    $[87] = t87;
    $[88] = t88;
  } else {
    t85 = $[85];
    t86 = $[86];
    t87 = $[87];
    t88 = $[88];
  }
  let t89;
  if ($[89] !== t84) {
    t89 = <linearGradient id={t84} gradientUnits="userSpaceOnUse" x1="-8524.128" y1="2023.3" x2="-8303.475" y2="2023.3" gradientTransform="matrix(.296 -.448 -.448 -.296 3456.332 -3102.04)">{t85}{t86}{t87}{t88}</linearGradient>;
    $[89] = t84;
    $[90] = t89;
  } else {
    t89 = $[90];
  }
  const t90 = `${prefix}J`;
  let t91;
  let t92;
  let t93;
  let t94;
  if ($[91] === Symbol.for("react.memo_cache_sentinel")) {
    t91 = <stop offset=".323" stopColor="#9e2064" />;
    t92 = <stop offset=".63" stopColor="#c92037" />;
    t93 = <stop offset=".751" stopColor="#cd2335" />;
    t94 = <stop offset="1" stopColor="#e97826" />;
    $[91] = t91;
    $[92] = t92;
    $[93] = t93;
    $[94] = t94;
  } else {
    t91 = $[91];
    t92 = $[92];
    t93 = $[93];
    t94 = $[94];
  }
  let t95;
  if ($[95] !== t90) {
    t95 = <linearGradient id={t90} gradientUnits="userSpaceOnUse" x1="-8537.816" y1="2024.407" x2="-8317.163" y2="2024.407" gradientTransform="matrix(.296 -.448 -.448 -.296 3456.332 -3102.04)">{t91}{t92}{t93}{t94}</linearGradient>;
    $[95] = t90;
    $[96] = t95;
  } else {
    t95 = $[96];
  }
  const t96 = `${prefix}M`;
  let t100;
  let t97;
  let t98;
  let t99;
  if ($[97] === Symbol.for("react.memo_cache_sentinel")) {
    t97 = <stop offset=".323" stopColor="#9e2064" />;
    t98 = <stop offset=".63" stopColor="#c92037" />;
    t99 = <stop offset=".751" stopColor="#cd2335" />;
    t100 = <stop offset="1" stopColor="#e97826" />;
    $[97] = t100;
    $[98] = t97;
    $[99] = t98;
    $[100] = t99;
  } else {
    t100 = $[97];
    t97 = $[98];
    t98 = $[99];
    t99 = $[100];
  }
  let t101;
  if ($[101] !== t96) {
    t101 = <linearGradient id={t96} gradientUnits="userSpaceOnUse" x1="-8524.128" y1="2016.46" x2="-8303.475" y2="2016.46" gradientTransform="matrix(.296 -.448 -.448 -.296 3456.332 -3102.04)">{t97}{t98}{t99}{t100}</linearGradient>;
    $[101] = t96;
    $[102] = t101;
  } else {
    t101 = $[102];
  }
  let t102;
  if ($[103] !== t101 || $[104] !== t12 || $[105] !== t18 || $[106] !== t24 || $[107] !== t30 || $[108] !== t36 || $[109] !== t42 || $[110] !== t48 || $[111] !== t54 || $[112] !== t59 || $[113] !== t6 || $[114] !== t65 || $[115] !== t71 || $[116] !== t77 || $[117] !== t83 || $[118] !== t89 || $[119] !== t95) {
    t102 = <defs>{t6}{t12}{t18}{t24}{t30}{t36}{t42}{t48}{t54}{t59}{t65}{t71}{t77}{t83}{t89}{t95}{t101}</defs>;
    $[103] = t101;
    $[104] = t12;
    $[105] = t18;
    $[106] = t24;
    $[107] = t30;
    $[108] = t36;
    $[109] = t42;
    $[110] = t48;
    $[111] = t54;
    $[112] = t59;
    $[113] = t6;
    $[114] = t65;
    $[115] = t71;
    $[116] = t77;
    $[117] = t83;
    $[118] = t89;
    $[119] = t95;
    $[120] = t102;
  } else {
    t102 = $[120];
  }
  const t103 = `url(#${prefix}i)`;
  let t104;
  if ($[121] !== t103) {
    t104 = <path fill={t103} d="M23.902 10.133a38.039 38.039 0 0 0-1.597 10.62l5.707 2.763a72.4 72.4 0 0 1 .398-10.164c.024-.23.047-.368.047-.368 0 .125-.035.243-.047.368a64.129 64.129 0 0 0-.012 10.027 110.54 110.54 0 0 0 8.457-8 12.174 12.174 0 0 0-6.37-6.805s-5.055-2.039-6.583 1.559Z" />;
    $[121] = t103;
    $[122] = t104;
  } else {
    t104 = $[122];
  }
  const t105 = `url(#${prefix}n)`;
  let t106;
  if ($[123] !== t105) {
    t106 = <path fill={t105} d="M29.52 40.367a231.874 231.874 0 0 1-.72-5.597 112.17 112.17 0 0 1-.523-5.633c0-.114-.02-.227 0-.325a89.502 89.502 0 0 1-.277-5.3l-5.7-2.746c0 .343-.038.699-.054 1.074-.055 1.363-.098 2.8-.11 4.34 0 1.718 0 3.511.032 5.386.039 1.73.113 3.532.203 5.364.094 1.566.195 3.148.324 4.765v.184l7.625 3.86c-.254-1.801-.53-3.594-.8-5.372Z" />;
    $[123] = t105;
    $[124] = t106;
  } else {
    t106 = $[124];
  }
  const t107 = `url(#${prefix}o)`;
  let t108;
  if ($[125] !== t107) {
    t108 = <path fill={t107} d="M40.8 85.45c.4 1.421.848 2.89 1.313 4.378v.059c.063.218.114.422.196.629.304 1.004.593 1.894 1.226 3.937A7.694 7.694 0 0 1 47.91 95.5a6.244 6.244 0 0 0-4.164-2.266 13.38 13.38 0 0 0 7.309-11.906 15.897 15.897 0 0 0-.188-1.305 5.387 5.387 0 0 1-3.062 4.61 15.057 15.057 0 0 0 2.437-9.492 29.88 29.88 0 0 0-.297-2.477 12.23 12.23 0 0 1-7.09 9.848l-2.312 2.129c.086.265.156.53.258.808Z" />;
    $[125] = t107;
    $[126] = t108;
  } else {
    t108 = $[126];
  }
  const t109 = `url(#${prefix}p)`;
  let t110;
  if ($[127] !== t109) {
    t110 = <path fill={t109} d="M37.813 78.941c-.485-1.808-.97-3.644-1.461-5.496A361.37 361.37 0 0 1 35 68.06c-.445-1.817-.871-3.645-1.297-5.47-.422-1.827-.84-3.737-1.23-5.6-.395-1.864-.762-3.723-1.13-5.575-.132-.672-.25-1.324-.37-2-.211-1.14-.403-2.293-.61-3.45a.618.618 0 0 0-.039-.187l-7.582-3.87c.02.12.028.241.031.366.153 1.715.297 3.457.504 5.2.203 1.738.422 3.558.688 5.363.223 1.52.465 3.027.715 4.55.05.301.113.618.164.915a109.705 109.705 0 0 0 2.555 10.828c.328 1.101.652 2.168.984 3.176.289.847.601 1.699.902 2.539a73.593 73.593 0 0 0 2.399 5.754l7.66 3.879c-.399-1.41-.801-2.84-1.2-4.293-.113-.418-.214-.825-.331-1.243Z" />;
    $[127] = t109;
    $[128] = t110;
  } else {
    t110 = $[128];
  }
  const t111 = `url(#${prefix}q)`;
  let t112;
  if ($[129] !== t111) {
    t112 = <path fill={t111} d="M31.79 80.832a59.387 59.387 0 0 0 3.523 6.508c.042.062.085.152.132.215a15.505 15.505 0 0 0-5.84-.45 21.445 21.445 0 0 1 9.41 5.485 9.865 9.865 0 0 1-4.449 2.23 9.838 9.838 0 0 0 4.883-.433 12.014 12.014 0 0 0-2.969 5.789 12.343 12.343 0 0 1 4.82-5.106c2.302 7.625 5.067 15.89 8.138 24.563.476-.617.609-1.43.359-2.164-.567-1.559-4.219-11.871-8.383-25.871-.117-.403-.223-.801-.355-1.203-.036-.114-.063-.215-.098-.336a749.886 749.886 0 0 1-1.305-4.528c-.097-.36-.199-.695-.297-1.058l-7.66-3.88c.024.083.051.16.09.239Z" />;
    $[129] = t111;
    $[130] = t112;
  } else {
    t112 = $[130];
  }
  const t113 = `url(#${prefix}r)`;
  let t114;
  if ($[131] !== t113) {
    t114 = <path fill={t113} d="M31.223 45.902c.047.258.093.485.136.746.149.758.282 1.528.438 2.301.16.844.336 1.703.504 2.586.082.445.168.89.261 1.344.278 1.36.579 2.754.887 4.187.399 1.766.797 3.579 1.242 5.465.403 1.785.871 3.645 1.344 5.535.461 1.805.926 3.653 1.438 5.567.449 1.691.93 3.43 1.418 5.199 0 .082.058.176.074.262a632.38 632.38 0 0 0 1.543 5.41.305.305 0 0 0 .035.117l2.312-2.129c-.058 0-.101.051-.18.082a22.18 22.18 0 0 0 5.634-12.453 29.749 29.749 0 0 0-.075-6.95 47.27 47.27 0 0 0-1.109-5.944 78.476 78.476 0 0 0-1.7-5.825 11.615 11.615 0 0 1-1.765 2.551l-.398.438c-.133.148-.282.277-.43.433a13.5 13.5 0 0 0 1.664-10.027 12.698 12.698 0 0 1-2.289 3.965c-.152.183-.332.363-.512.543-.047.035-.082.082-.144.133a13.94 13.94 0 0 0 1.484-3.258c.07-.223.13-.45.172-.68.082-.348.137-.7.188-1.05.02-.235.058-.45.078-.684a9.725 9.725 0 0 0 0-1.653c0-.183 0-.347-.043-.52-.047-.257-.078-.495-.125-.73a41.03 41.03 0 0 0-.598-2.8c-.102-.399-.2-.766-.305-1.098-.047-.133-.07-.262-.117-.403-.125-.363-.226-.699-.336-.976a10.217 10.217 0 0 0-.422-.969 2.14 2.14 0 0 1-.168.457 15.014 15.014 0 0 1-2.597 3.739l2.129-1.95-2.145 1.938a.08.08 0 0 0-.035.05 4.49 4.49 0 0 0-.313.348c0-.027.04-.05.043-.074l-7.28 6.66c.058.05.066.09.062.117Z" />;
    $[131] = t113;
    $[132] = t114;
  } else {
    t114 = $[132];
  }
  const t115 = `url(#${prefix}s)`;
  let t116;
  if ($[133] !== t115) {
    t116 = <path fill={t115} d="M28.398 23.379c.09 1.601.23 3.394.403 5.379.004.101.015.207.035.308.164 1.735.375 3.602.648 5.637.23 1.758.489 3.602.801 5.602.258 1.73.578 3.543.906 5.468l7.282-6.668a11.974 11.974 0 0 0 1.828-6.59c0-.57-.043-1.171-.09-1.788A56.41 56.41 0 0 0 39.578 25a49.186 49.186 0 0 0-1.082-5.148 28.214 28.214 0 0 0-.836-2.614 32.462 32.462 0 0 0-.8-1.812 115.46 115.46 0 0 1-8.462 7.953Z" />;
    $[133] = t115;
    $[134] = t116;
  } else {
    t116 = $[134];
  }
  const t117 = `url(#${prefix}z)`;
  let t118;
  if ($[135] !== t117) {
    t118 = <path fill={t117} d="M98.508 11.563a43.16 43.16 0 0 0-9.707 7.289l2.398 6.761a80.326 80.326 0 0 1 8.403-7.86c.203-.167.328-.265.328-.265-.106.098-.227.168-.328.266a71.75 71.75 0 0 0-8 8.05c4.375.325 8.765.423 13.152.29a13.78 13.78 0 0 0 .281-10.559s-2.445-5.656-6.527-3.973Z" />;
    $[135] = t117;
    $[136] = t118;
  } else {
    t118 = $[136];
  }
  const t119 = `url(#${prefix}E)`;
  let t120;
  if ($[137] !== t119) {
    t120 = <path fill={t119} d="M79.004 40.363a318.718 318.718 0 0 1 3.871-5.086 138.623 138.623 0 0 1 4.055-4.949c.078-.101.164-.195.238-.277a135.156 135.156 0 0 1 4-4.465l-2.398-6.742c-.286.27-.59.535-.899.82a136.81 136.81 0 0 0-3.535 3.402 222.161 222.161 0 0 0-4.258 4.368 220.475 220.475 0 0 0-4.09 4.472 260.517 260.517 0 0 0-3.527 4.098l-.137.156 3.067 9.164c1.222-1.652 2.418-3.324 3.613-4.96Z" />;
    $[137] = t119;
    $[138] = t120;
  } else {
    t120 = $[138];
  }
  const t121 = `url(#${prefix}F)`;
  let t122;
  if ($[139] !== t121) {
    t122 = <path fill={t121} d="M52.254 85.602c-.8 1.476-1.602 3-2.422 4.566 0 .02-.027.039-.031.059-.121.23-.242.433-.34.66-.555 1.05-1.023 2-2.137 4.144a8.72 8.72 0 0 1 2.692 4.32 7.08 7.08 0 0 0-1.551-5.128c6.23 1.203 11.89.402 15.344-3.778.3-.379.597-.777.882-1.203a6.088 6.088 0 0 1-6.129 1.274 17.043 17.043 0 0 0 9.504-5.715 35.594 35.594 0 0 0 1.727-2.235 13.818 13.818 0 0 1-13.531 2.297l-3.555-.125c-.152.305-.309.575-.453.864Z" />;
    $[139] = t121;
    $[140] = t122;
  } else {
    t122 = $[140];
  }
  const t123 = `url(#${prefix}G)`;
  let t124;
  if ($[141] !== t123) {
    t124 = <path fill={t123} d="M55.031 78c1.047-1.844 2.117-3.703 3.2-5.602a296.203 296.203 0 0 1 3.203-5.406c1.097-1.808 2.195-3.625 3.3-5.437a282.35 282.35 0 0 1 3.47-5.5c1.175-1.825 2.347-3.598 3.515-5.383a86.9 86.9 0 0 1 1.3-1.914c.739-1.09 1.497-2.18 2.254-3.262.032-.059.082-.121.114-.184l-3.028-9.136a2.994 2.994 0 0 1-.265.316c-1.242 1.504-2.504 3.024-3.739 4.598-1.242 1.504-2.504 3.024-3.739 4.598-1.23 1.57-2.488 3.2-3.707 4.867a265.274 265.274 0 0 0-3.039 4.23c-.199.282-.402.586-.593.868-1.2 1.797-2.364 3.558-3.387 5.25a113.286 113.286 0 0 0-3.156 5.5 134.34 134.34 0 0 0-1.735 3.34c-.441.91-.867 1.843-1.289 2.757a85.328 85.328 0 0 0-2.644 6.535l3.082 9.2c.8-1.461 1.625-2.914 2.445-4.403.219-.394.469-.8.7-1.234Z" />;
    $[141] = t123;
    $[142] = t124;
  } else {
    t124 = $[142];
  }
  const t125 = `url(#${prefix}H)`;
  let t126;
  if ($[143] !== t125) {
    t126 = <path fill={t125} d="M48.68 74.742a67.607 67.607 0 0 0-2.332 8.043c0 .086-.051.192-.063.278a17.542 17.542 0 0 0-4.344-5.004 24.348 24.348 0 0 1 3.22 11.894 11.167 11.167 0 0 1-5.356-1.742 11.088 11.088 0 0 0 4.27 3.531 13.604 13.604 0 0 0-6.985 2.301 13.928 13.928 0 0 1 7.933-.273c-4.222 7.957-8.543 16.808-12.964 26.23a2.598 2.598 0 0 0 2-1.457c.8-1.703 6.043-12.902 13.812-27.488.219-.399.453-.82.672-1.254l.184-.348c.824-1.52 1.671-3.082 2.55-4.68.207-.37.399-.722.602-1.09v-.019l-3.082-9.2c-.047.09-.086.184-.117.278Z" />;
    $[143] = t125;
    $[144] = t126;
  } else {
    t126 = $[144];
  }
  const t127 = `url(#${prefix}I)`;
  let t128;
  if ($[145] !== t127) {
    t128 = <path fill={t127} d="M75.977 46.176c-.168.238-.313.465-.48.703-.485.73-.99 1.453-1.477 2.2a208.44 208.44 0 0 1-1.653 2.483c-.281.426-.566.848-.855 1.293-.86 1.317-1.723 2.676-2.617 4.075a347.967 347.967 0 0 0-3.34 5.383 502.867 502.867 0 0 0-3.317 5.523c-1.062 1.816-2.152 3.676-3.261 5.602-.985 1.718-1.977 3.5-3 5.324-.055.078-.094.183-.149.265a529.846 529.846 0 0 0-3.058 5.602.298.298 0 0 0-.067.125l3.555.121c-.063-.031-.13-.04-.215-.074a25.118 25.118 0 0 0 14.43-5.559 33.84 33.84 0 0 0 5.472-5.64 55.376 55.376 0 0 0 3.825-5.668 86.801 86.801 0 0 0 3.257-6.043c-1.113.37-2.27.59-3.441.648l-.676.035h-.687a15.28 15.28 0 0 0 9.304-6.75 14.342 14.342 0 0 1-4.992 1.375c-.27.028-.558.028-.847.031h-.22a15.9 15.9 0 0 0 3.778-1.437c.234-.121.465-.254.684-.402.343-.215.664-.453.984-.696.207-.168.402-.32.606-.488.472-.41.906-.855 1.304-1.34.137-.156.266-.293.375-.457.168-.238.332-.457.477-.683a40.85 40.85 0 0 0 1.758-2.735c.234-.398.445-.777.629-1.129.066-.144.148-.265.218-.398.192-.403.375-.746.508-1.059.16-.36.305-.73.426-1.11a2.336 2.336 0 0 1-.5.235 16.92 16.92 0 0 1-5.059.946l3.266.125-3.266-.125c-.023-.012-.047-.012-.066 0a5.675 5.675 0 0 0-.516 0c.028 0 .07 0 .094-.032l-11.16-.402c.02.074-.008.113-.031.133Z" />;
    $[145] = t127;
    $[146] = t128;
  } else {
    t128 = $[146];
  }
  const t129 = `url(#${prefix}J)`;
  let t130;
  if ($[147] !== t129) {
    t130 = <path fill={t129} d="M91.602 25.809a161.424 161.424 0 0 0-3.946 4.656c-.082.086-.156.18-.219.277a178.511 178.511 0 0 0-3.957 5.055c-1.199 1.598-2.48 3.297-3.816 5.16-1.168 1.598-2.348 3.316-3.602 5.121l11.16.402a13.554 13.554 0 0 0 6.712-3.847 45.42 45.42 0 0 0 1.351-1.508A66.175 66.175 0 0 0 99.313 36a56.266 56.266 0 0 0 3.199-5.004 29.64 29.64 0 0 0 1.402-2.766c.309-.73.566-1.421.8-2.097-4.374.113-8.75.004-13.112-.324Z" />;
    $[147] = t129;
    $[148] = t130;
  } else {
    t130 = $[148];
  }
  let t131;
  if ($[149] !== t102 || $[150] !== t104 || $[151] !== t106 || $[152] !== t108 || $[153] !== t110 || $[154] !== t112 || $[155] !== t114 || $[156] !== t116 || $[157] !== t118 || $[158] !== t120 || $[159] !== t122 || $[160] !== t124 || $[161] !== t126 || $[162] !== t128 || $[163] !== t130) {
    t131 = <svg viewBox="0 0 128 128">{t102}{t104}{t106}{t108}{t110}{t112}{t114}{t116}{t118}{t120}{t122}{t124}{t126}{t128}{t130}</svg>;
    $[149] = t102;
    $[150] = t104;
    $[151] = t106;
    $[152] = t108;
    $[153] = t110;
    $[154] = t112;
    $[155] = t114;
    $[156] = t116;
    $[157] = t118;
    $[158] = t120;
    $[159] = t122;
    $[160] = t124;
    $[161] = t126;
    $[162] = t128;
    $[163] = t130;
    $[164] = t131;
  } else {
    t131 = $[164];
  }
  return t131;
};
export default MavenIcon;